// extracted by mini-css-extract-plugin
export default {"faq":"cH4cg1bLr","tabsContainer":"clH0s5p8J","separator":"cvyBeeCEv"};